(ns scittle.emmy-viewers
  {:no-doc true}
  (:require [scittle.core :as scittle]
            [sci.core :as sci]
    [emmy.mafs]
    [emmy.viewer]
    [emmy.mathbox]
    [emmy.mathbox.plot]
    [emmy.mathbox.color]
    [emmy.leva]))

;; Plugin: emmy-viewers
;; Generated by build.clj

(defn init []
  (scittle/register-plugin!
   ::emmy-viewers
   {:namespaces
   {'emmy.mafs (sci/copy-ns emmy.mafs (sci/create-ns 'emmy.mafs nil))
    'emmy.viewer (sci/copy-ns emmy.viewer (sci/create-ns 'emmy.viewer nil))
    'emmy.mathbox (sci/copy-ns emmy.mathbox (sci/create-ns 'emmy.mathbox nil))
    'emmy.mathbox.plot (sci/copy-ns emmy.mathbox.plot (sci/create-ns 'emmy.mathbox.plot nil))
    'emmy.mathbox.color (sci/copy-ns emmy.mathbox.color (sci/create-ns 'emmy.mathbox.color nil))
    'emmy.leva (sci/copy-ns emmy.leva (sci/create-ns 'emmy.leva nil))}}
   ))
